module.exports = __webpack_public_path__ + "media/images/page/sorry-tx2-08c7277f5ca21d25449c09772284855f.png";